import React from "react"

import {
	setMetaTag,
} from "services/functions"

export default class HeadTags extends React.Component {

	componentDidMount() {
		const {data} = this.props
		setMetaTag("meta-description", data.headline)
		setMetaTag("meta-description-og", data.headline)
		setMetaTag("meta-title", data.title)
		setMetaTag("meta-title-og", data.title)
	}

	render() {
		return false
	}
}
